import React from 'react';
import { Col, Row } from 'reactstrap';
import { useApiGet } from 'hooks/useApi';
import Device from 'models/Device';
import { useParams } from 'react-router-dom';

type ResourceItemProps = {
  label: string;
  value?: string | null;
  testId: string;
};

const ResourceItem = ({ label, value, testId }: ResourceItemProps) => {
  const displayValue = value && value.trim() ? value : '—';

  return (
    <Col className="mt-2">
      <div>
        <div className="text-gray-600 fw-medium">{label}</div>
        <div className="border rounded px-3 py-2 bg-white" data-testid={testId}>
          {displayValue}
        </div>
      </div>
    </Col>
  );
};

const ResourcesPage = () => {
  const params = useParams();
  const { data: device } = useApiGet<Device>(`/device`, {
    id: params.id,
    enabled: !!params.id
  });

  return (
    <div className="mt-4">
      <Row xs="2" className="d-flex align-items-center shadow bg-white form">
        <ResourceItem
          label="Sistema Operacional"
          value={device?.player?.so}
          testId="so"
        />
        <ResourceItem
          label="Versão Player"
          value={device?.player?.playerVersion}
          testId="playerVersion"
        />
        <ResourceItem
          label="Total de Memória RAM"
          value={device?.player?.menRam}
          testId="menRam"
        />
        <ResourceItem
          label="Armazenamento Total"
          value={device?.player?.storageSize}
          testId="storageSize"
        />
        <ResourceItem
          label="Utilizado HD"
          value={device?.player?.storageUsed}
          testId="storageUsed"
        />
        <ResourceItem
          label="Marca do dispositivo"
          value={device?.player?.brand}
          testId="brand"
        />
        <ResourceItem
          label="Modelo do dispositivo"
          value={device?.player?.model}
          testId="model"
        />
        <ResourceItem
          label="Processador"
          value={device?.player?.processor}
          testId="processor"
        />
        <ResourceItem label="IP" value={device?.player?.ip} testId="ip" />
        <ResourceItem
          label="GUID"
          value={device?.player?.machineId}
          testId="guid"
        />
      </Row>
    </div>
  );
};

export default ResourcesPage;
